import React from 'react'
import PaperPage from 'src/components/organisms/whitepapers/PaperPage'
import thumbnail from 'src/images/whitepapers/commmune-community-marketing.png'

const paperInfo = {
  paperName: 'コミュニティマーケティング超入門',
  thumbnail,
  feature1: 'コミュニティマーケティングとは何か',
  feature2: 'なぜいまコミュニティマーケティングが重要なのか',
  feature3: 'なぜコミュニティがユーザーインサイト獲得に効果的なのか',
  description:
    'いま注目される「コミュニティマーケティング」とはどのようなものか、なぜいま重要なのかについて、社会的な背景や実際のコミュニティ施策先行企業の事例も含めてご紹介をいたします。',
  formSrc: 'https://go.commmune.jp/l/915341/2021-03-06/g83',
  type: 'pardot' // TODO: HubSpotからPardotに移行したらこのタグ付けが不要になるので削除する
}

const WhitePaperPage = () => {
  return <PaperPage {...paperInfo} />
}

export default WhitePaperPage
